<ion-header class="ion-no-shadow ion-no-border">
    <header-notifications></header-notifications>
    <ion-toolbar class="ion-hide-xl-up">
        <ion-menu-button *ngIf="!plt.tabMenu"></ion-menu-button>
        <a *ngIf="plt.tabMenu"
           [routerLink]="[plt.defaultLink + '/appointments']"
           class="back-link">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-arrow.svg"></svg-icon>

        </a>
        <ion-title class="full"
                   [innerHTML]="'TIMESLOTS_HEADER' | trns"></ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-refresher (ionRefresh)="refresh($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <div class="content-box timeslots"
         *ngIf="!loading">

        <a *ngIf="!plt.tabMenu"
           [routerLink]="[plt.defaultLink + '/appointments']"
           class="back-link">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-arrow.svg"></svg-icon>
            {{ 'TIMESLOTS_BACK_TO_APPOINTMENTS' | trns }}
        </a>

        <h1 [innerHTML]="'TIMESLOTS_HEADER' | trns"></h1>

        <p [innerHTML]="'TIMESLOTS_HINT' | trns"></p>
        <p [innerHTML]="'TIMESLOTS_NOTE' | trns"></p>

        <ion-select [interface]="selectType"
                    [interfaceOptions]="{cssClass: days.length < 5 ?'not-overflow': ''}"
                    name="selected_day"
                    [(ngModel)]="selectedDay">
            <ion-select-option [value]="0">
                {{ 'TIMESLOTS_BUTTON_ALL_DAYS' | trns }}
            </ion-select-option>
            <ion-select-option *ngFor="let day of days"
                               [value]="day.getTime()">
                {{ participantTimeslot.timeslots['items'][day.getTime()][0].start | datex: 'dateFormatDayName':null:true }}
            </ion-select-option>
        </ion-select>

        <ng-container *ngFor="let day of days; let i = index">
            <div *ngIf="selectedDay == 0 || selectedDay == day.getTime()"
                 [ngClass]="{'first': i == 0}"
                 class="day-slot {{'column-' + (60/participantTimeslot.timeslots['timeslot_length']) }}">
                <div class="content-box-inner">
                    <div class="content-header">
                        <div class="day-header">
                            <ion-grid class="ion-no-padding">
                                <ion-row>
                                    <ion-col size="5"
                                             class="ion-no-padding">
                                        <h2>{{ participantTimeslot.timeslots['items'][day.getTime()][0].start | datex: 'dddd':null:true }} <span>{{ participantTimeslot.timeslots['items'][day.getTime()][0].start 
                                             | datex:'':null:true }}</span></h2>
                                    </ion-col>
                                    <ion-col size="7"
                                             class="ion-no-padding ion-text-right">
                                        <ion-row class="ion-no-padding ion-align-items-center">
                                            <ion-col class="ion-no-padding">
                                                <ion-item class="ion-no-padding ion-float-right">
                                                    <ion-checkbox [(ngModel)]="day.selectAll"
                                                                  (ngModelChange)="selectAllDay(day);"></ion-checkbox>
                                                    <ion-label>{{ 'TIMESLOTS_SELECT_ALL' | trns }}</ion-label>
                                                </ion-item>
                                            </ion-col>
                                            <ion-col *ngIf="!plt.tabMenu"
                                                     class="ion-no-padding">
                                                <ion-button [disabled]="!allowEdit"
                                                            (click)="changeStatus('free')">
                                                    {{ 'TIMESLOTS_MARK_AS_FREE' | trns }}
                                                </ion-button>
                                            </ion-col>
                                            <ion-col *ngIf="!plt.tabMenu"
                                                     class="ion-no-padding">
                                                <ion-button [disabled]="!allowEdit"
                                                            (click)="changeStatus('blocked')">
                                                    {{ 'TIMESLOTS_MARK_AS_BLOCKED' | trns }}
                                                </ion-button>
                                            </ion-col>
                                        </ion-row>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </div>
                    </div>

                    <div class="content-data">
                        <ng-container *ngFor="let slot of participantTimeslot.timeslots['items'][day.getTime()];  let i=index">
                            <!-- break actual slots block every hour, slot lenght is in minutes  -->
                            <ng-container *ngIf="(i + dailyOffset[day.getTime()]) % (60/participantTimeslot.timeslots['timeslot_length']) == 0 && i > 0">
                                <div class="breaker"></div>
                            </ng-container>

                            <!-- show block header which is start hour for this block -->
                            <ng-container
                                          *ngIf="generateHourlyTimes && (((i + dailyOffset[day.getTime()]) % (60/participantTimeslot.timeslots['timeslot_length']) == 0) || (i == 0 && (dailyOffset[day.getTime()] % 1 == 0)))">

                                <label class="hour"
                                       (click)="hourCheckChanged(slot.start.valueOf() - (slot.start.valueOf() % 3600000))"
                                       [ngClass]="{'selected': hourCheck[slot.start.valueOf() - (slot.start.valueOf() % 3600000)]}">
                                    <!-- <ion-checkbox class="ion-no-padding ion-no-margin"
                                                  [(ngModel)]="hourCheck[slot.start.valueOf() - (slot.start.valueOf() % 3600000)]"
                                                  (ngModelChange)="hourCheckChanged(slot.start.valueOf() - (slot.start.valueOf() % 3600000))"></ion-checkbox> -->
                                    <div class="checkbox">
                                        <svg class="checkbox-icon"
                                             viewBox="0 0 24 24">
                                            <path d="M5.9,12.5l3.8,3.8l8.8-8.8"></path>
                                        </svg>
                                    </div>
                                    <span class="pointer lowercase">
                                        {{ slot.start | datex: 'timeFormatDefault':null:true }}
                                    </span>
                                </label>

                            </ng-container>
                            <div
                                 class="slot timeslot {{slot.selected ? 'selected' : ''}} {{ slot.appointment ? 'appointment' : slot.status }} {{!slot.selected && !slot.appointment ? 'selectable' : ''}}">
                                <label (click)="slotSelected(slot)">
                                    <!-- <ion-checkbox class="ion-no-padding"
                                                  *ngIf="!slot.appointment"
                                                  [(ngModel)]="slot.selected"
                                                  (ngModelChange)="slotSelected()"></ion-checkbox> -->
                                    <div class="checkbox">
                                        <svg class="checkbox-icon"
                                             viewBox="0 0 24 24">
                                            <path d="M5.9,12.5l3.8,3.8l8.8-8.8"></path>
                                        </svg>
                                    </div>
                                    <svg-icon *ngIf="slot.appointment"
                                              [applyClass]="true"
                                              src="/assets/icons/ico-attendee.svg"
                                              class="icon"></svg-icon>
                                    <svg-icon *ngIf="!slot.appointment && slot.status == 'blocked'"
                                              [applyClass]="true"
                                              src="/assets/icons/ico-full-slot.svg"
                                              class="icon blocked"></svg-icon>

                                    <!-- show space instead of checkbox if this block is with appointment -->
                                    <div (click)="slot.appointment ? displayAppointmentList(slot.appointment?.id) : null">
                                        <span class="time-block">{{ slot.start | datex: 'timeFormatJustNumbers':null:true }}-<span [innerHtml]="slot.end | datex: 'timeFormatDefaultEnd':null:true"></span></span>
                                    </div>
                                </label>

                                <ion-anchor *ngIf="!slot.appointment && slot.status == 'blocked'"
                                            (click)="presentAddNote($event, slot)"
                                            class="edit">
                                    <ion-icon name="create-outline"
                                              color="dark">
                                    </ion-icon>
                                </ion-anchor>
                            </div>

                        </ng-container>
                        <div class="breaker"></div>

                    </div>
                </div>
            </div>
        </ng-container>

    </div>
    <ng-container *ngIf="loading">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>
</ion-content>

<ion-footer *ngIf="plt.tabMenu">
    <ion-row class="action-buttons two ion-no-padding">
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button class="btn-close"
                        [disabled]="!allowEdit"
                        (click)="changeStatus('free')">
                {{ 'TIMESLOTS_MARK_AS_FREE' | trns }}
            </ion-button>
        </ion-col>
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button class="btn-close"
                        [disabled]="!allowEdit"
                        (click)="changeStatus('blocked')">
                {{ 'TIMESLOTS_MARK_AS_BLOCKED' | trns }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>